import { QuestionGroupType } from '@exam-management/graphql';
import { Flex, styled, PaperSection } from '@shared/components';

import type { Question } from '../../types';
import { ItemSetQuestionDetails } from '../item-set-question-details';
import { SingleQuestionDetails } from '../single-question-details';

const Wrapper = styled(Flex)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(4),
  padding: theme.spacing(6),
}));

interface QSetQuestionDetailsProps {
  question: Question;
  order: number;
  endAdornment?: JSX.Element;
}

export default function QSetQuestionDetails(props: Readonly<QSetQuestionDetailsProps>) {
  const { question, order, endAdornment } = props;

  return (
    <PaperSection title={`ข้อ ${order}`} endAdornment={endAdornment}>
      <Wrapper>
        {question.questionGroup?.type === QuestionGroupType.Single ||
        question.questionGroup?.type === QuestionGroupType.LotOfQuestion ? (
          <SingleQuestionDetails question={question} />
        ) : null}
        {question.questionGroup?.type === QuestionGroupType.ItemSet ? (
          <ItemSetQuestionDetails question={question} />
        ) : null}
      </Wrapper>
    </PaperSection>
  );
}
